function normalizePath(value: string): string {
  const raw = String(value || '').trim() || '/';
  return raw.startsWith('/') ? raw : '/';
}

function decodeBase64Url(value: string): string | null {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return decodeURIComponent(
      Array.from(atob(padded), (char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
    );
  } catch {
    return null;
  }
}

function encodeBase64Url(value: string): string {
  const bytes = encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
  return btoa(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function encodeStartAppNavPath(desiredPath: string): string {
  return `nav_${encodeBase64Url(normalizePath(desiredPath))}`;
}

export function decodeStartAppNavPath(startParam: string): string | null {
  const raw = String(startParam || '').trim();
  if (!raw.startsWith('nav_')) return null;
  const payload = raw.slice(4);
  if (!payload) return null;

  let decoded: string | null = null;
  try {
    decoded = payload.includes('%') ? decodeURIComponent(payload) : decodeBase64Url(payload);
  } catch {
    decoded = null;
  }
  if (!decoded) return null;
  return decoded.startsWith('/') ? decoded : null;
}

export function buildTelegramStartAppLink(botUsername: string, desiredPath: string): string {
  const bot = String(botUsername || '').trim().replace(/^@/, '');
  const base = `https://t.me/${encodeURIComponent(bot)}`;
  if (!bot) return base;
  const payload = encodeStartAppNavPath(desiredPath);
  if (payload.length > 128) return base;
  return `${base}?startapp=${payload}&mode=compact`;
}
